<template>
  <v-autocomplete
    v-model="missionSelected"
    :items="missions"
    item-text="name"
    item-value="id"
    label="Mission"
    clearable
    :loading="loading"
  ></v-autocomplete>
</template>

<script>
import { denormalize } from "@/helpers/JsonApiDenormalizer";
import { MissionService } from "@/services/mission.service";

export default {
  props: {
    value: {
      type: String,
    },
  },
  data: () => ({
    missionSelected: "",
    missions: [],
    loading: false,
  }),
  mounted() {
    this.fetchMissions();
  },
  watch: {
    value(value) {
      this.missionSelected = value;
    },
    missionSelected(mission) {
      this.$emit("update:value", mission);
    },
  },
  methods: {
    async fetchMissions() {
      try {
        this.loading = true;

        this.missions = await MissionService.all().then((response) =>
          denormalize(response.data)
        );

        this.missionSelected = this.value;
      } catch (err) {
        console.error(err);
        throw err;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>